(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("notificationsDashboard", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/notifications/notificationsDashboardView.html",
            controller: ["notificationResource", "$sessionStorage", "$state", "$translate", "$timeout", "DTOptionsBuilder", "DTColumnDefBuilder", NotificationsDashboardCtrl],
            controllerAs: "vm"
        };
        function NotificationsDashboardCtrl(notificationResource, $sessionStorage, $state, $translate, $timeout, DTOptionsBuilder, DTColumnDefBuilder) {
            var vm = this;
            var lang = $translate.proposedLanguage() || $translate.use();
            vm.loading = true;
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withLanguageSource("/app/i18n/datatables/" + lang + ".json")
                .withOption("processing", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("order", [1, "asc"])
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumnDefs = [
                DTColumnDefBuilder.newColumnDef(0).withOption("class", "control").withOption("sortable", false).withOption("targets", 0)
            ];
            notificationResource.getNotificationTemplates(function (data) {
                vm.notificationTemplates = data.notificationTemplates;
                $timeout(function () {
                    vm.loading = false;
                });
            });
            if ($sessionStorage.manageNotificationTemplateFilters) {
                vm.dtSearch = $sessionStorage.manageNotificationTemplateFilters.search;
            }
            else {
                vm.dtSearch = "";
            }
            vm.gotoTemplate = function (id) {
                $state.go("main.settings.editNotificationTemplate", { id: id });
            };
            vm.dtInstanceCallback = function (instance) {
                vm.dtInstance = instance;
            };
            vm.search = function () {
                $sessionStorage.manageNotificationTemplateFilters = { search: vm.dtSearch };
                vm.dtInstance.DataTable.search(vm.dtSearch).draw();
            };
        }
    });
})();
